import { motion, AnimatePresence } from 'framer-motion';
import Lottie from 'react-lottie';
import { memo } from 'react';
import animationData from '../../assets/animations/Clouds.json';

export type AnimatedBackgroundU = 'upgradePage' | 'upgradeUnlockLevel' | 'slotPage' | 'leaderboard' | 'chests';

type AnimatedBackgroundProps = {
    backgroundPage: AnimatedBackgroundU;
};

const backgroundClasses = {
  upgradePage: 'bg-upgradePageBg',
  upgradeUnlockLevel: 'bg-dropBankBg',
  slotPage: 'bg-slotBG',
  leaderboard: 'bg-leaderboardBG',
  chests: 'chests-bg',
};
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

function AnimatedBackground({ backgroundPage }: AnimatedBackgroundProps) {
  return (
    <div className="absolute top-0 left-0 w-full h-full z-0 overflow-hidden bg-fullfull">
      <AnimatePresence mode="wait">
        <motion.div
          key={backgroundPage}
          className={`absolute top-0 left-0 w-full h-full bg-cover ${backgroundClasses[backgroundPage]}`}
          initial={{ opacity: 0.3 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.3 }}
          transition={{ duration: 1 }}
        />
      </AnimatePresence>

      <Lottie
        options={{
          animationData,
        }}
        height="unset"
        width={isSafari ? '100vw' : 'unset'}
        isClickToPauseDisabled
      />
    </div>
  );
}

export default memo(AnimatedBackground);
